
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton, AppInput, AppFormRow, AppAvatarBreadcrumb } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useAvatarCategorytList } from '@/modules/avatar/category/model/list';
import { AvatarGender } from '@/modules/avatar/gender/model/gender';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.CATEGORY.INDEX,
    components: { AppTable, AppCard, AppButton, AppInput, AppFormRow, AppAvatarBreadcrumb },
    setup() {
        const { query, v$, list, total, fetchList, actions } = useAvatarCategorytList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Position', key: 'position' },
                { type: TableColumnType.Option, label: 'Gender', key: 'gender', options: AvatarGender },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Boolean, label: 'Is body', key: 'isBody' },
                { type: TableColumnType.Boolean, label: 'Is published', key: 'isPublished' },
                { type: TableColumnType.Boolean, label: 'Is required', key: 'isRequired' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-leaf',
                        theme: 'info',
                        tooltip: 'View items',
                        to: { name: ROUTE_NAME_AVATAR.ITEM.INDEX, query: { categoryId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.CATEGORY.EDIT, params: { categoryId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-indent',
                        theme: 'info',
                        tooltip: 'View sub categories',
                        to: { name: ROUTE_NAME_AVATAR.CATEGORY.INDEX, query: { parentId: row.id } }
                    }),
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { query, v$, table, list, total, fetchList, actions, ROUTE_NAME_AVATAR };
    }
});
